import { Checkbox } from '@chakra-ui/react'
import { iPermissaoFuncionalidade } from '../../../../../contexts/AuthContext'
import { blackList, PermissoesOrdenadas, renomearFuncionalidades } from '../permissoesHelper'
import { Container } from './styles'

interface TabelaProps {
  permissao: iPermissaoFuncionalidade[]
  onToggle: (modulo: string, funcionalidade: string, tipoUsuario: number, permitir: boolean) => void
}

export const TabelaPermissoesIndividuais: React.FC<TabelaProps> = ({ permissao, onToggle }) => {
  function TemPermissao(tipo: number, funcionaliade: string): boolean {
    return permissao.find(e => e.tipoUsuario === tipo && e.funcionalidade === funcionaliade)?.permitir as boolean
  }

  return (
    <Container>
      <thead>
        <tr>
          <th style={{ textAlign: 'start' }}>Funcionalidade</th>
          <th>Colaborador</th>
          <th>Gestor</th>
        </tr>
      </thead>
      <tbody>
        {
          PermissoesOrdenadas(permissao).map((e, i) => {
            return (
              <tr key={i}>
                <td style={{ textAlign: 'start' }}>
                  {renomearFuncionalidades(e.funcionalidade)}
                </td>
                <td>
                  <div className='tdCenter'>
                    {!blackList?.some(r => r === e.funcionalidade) &&
                      <Checkbox
                        onChange={(c) => onToggle(e.modulo, e.funcionalidade, 0, c.target.checked)}
                        isDisabled={e.tipoUsuario === 0 && e.funcionalidade.toLowerCase().includes('dash')}
                        isChecked={TemPermissao(0, e.funcionalidade)}
                        borderColor={'var(--Gray4)'}
                      />}
                  </div>
                </td>
                <td>
                  <div className='tdCenter'>
                    <Checkbox onChange={(c) => onToggle(e.modulo, e.funcionalidade, 1, c.target.checked)}
                      isChecked={TemPermissao(1, e.funcionalidade)}
                      borderColor={'var(--Gray4)'}
                    />
                  </div>
                </td>
              </tr>
            )
          })
        }
      </tbody>
    </Container>
  )
}
